import { createRef, useCallback } from 'react'
import { BottomSheetModal } from '@gorhom/bottom-sheet'

export const cheatSheetModalRef = createRef<BottomSheetModal>()

export const useCheatSheet = () => {
  const open = useCallback(() => {
    cheatSheetModalRef.current?.present()
  }, [])

  const close = useCallback(() => {
    cheatSheetModalRef.current?.close()
  }, [])

  return {
    ref: cheatSheetModalRef,
    open,
    close
  }
}
